import { useQuery } from "react-query";
import { AppConstant, KeyConstant } from "@/const";
import { PaginationType } from "@/types/common";
import { PersonService } from "@/services";
import dayjs from "dayjs";

export type CodeSearchFilterValue = {
  filter?: string;
  start?: Date | null;
  end?: Date | null;
};

export type CodeSearchPayloadType = {
  paginationParam: Partial<PaginationType>;
  filterParam: CodeSearchFilterValue;
};

const useCodeSearchList = (props: CodeSearchPayloadType) => {
  const { paginationParam, filterParam } = props;
  const { page, size } = paginationParam || {};
  const { filter, start, end } = filterParam || {};

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getPersonList, page, size, filterParam],
    queryFn: () => {
      return PersonService.getPersonList({
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
        identification: "",
        filter: filter,
        start_time: start ? dayjs(start)?.valueOf() : undefined,
        end_time: end ? dayjs(end)?.valueOf() : undefined,
      });
    },
  });

  const { data: requestList, ...pagination } = data || {};

  return {
    requestList: requestList || [],
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
    refetch,
  };
};

const MOCK_DATA = {
  message: "OK",
  error: null,
  data: [
    {
      ufilter: "232324234",
      code: "123",
      name: "Bùi Nhật Dương",
      filterentity: "231203214124",
      responseAt: 1756265587,
      source: "Cục Thủy sản",
      status: 1,
      state: 1,
      created: 1756265587,
    },
    {
      ufilter: "2323242353",
      code: "124",
      name: "Phan Đăng Quang",
      filterentity: "151203214124",
      responseAt: 1756265587,
      source: "Biên phòng",
      status: 1,
      state: 1,
      created: 1756265587,
    },
  ],
  status: 200,
  total_page: 1,
  size: 10,
  total: 0,
  page: 1,
};

export default useCodeSearchList;
